import { WindowSize } from 'src/app/enums/window-size.enum';
import { WindowStatus } from 'src/app/enums/window-status.enum';
import { IWindowContentCreation } from './window-content-creation.interface';
import { IWindowProcess } from './window-process.interface';

export class WindowProcess implements IWindowProcess {
  id: number;
  title: string;
  icon: string;
  extra: any = {};
  content: IWindowContentCreation = null;
  status = WindowStatus.Normal;
  overflow = false;
  visible = true;

  constructor(data?: IWindowProcess | any) {
    if (data) {
      Object.assign(this, data);
    }
  }

  hasFocus() {
    return this.extra.z === 100;
  }

  isMinimized(): boolean {
    return !this.visible;
  }

  isMaximized(): boolean {
    return this.status === WindowStatus.Maximized;
  }

  isFullscreen(): boolean {
    return this.status === WindowStatus.Fullscreen;
  }

  minimize() {
    this.visible = false;
  }

  restore() {
    this.visible = true;
  }
}
